module.exports = __webpack_public_path__ + "img/m_jiantou.e413f864.png";